import React from 'react';
import { useTreatmentContext } from '../../../../Services/TreatmentContext';
import Modal from '../../../../Components/Modal/Modal';
import { Size } from '../../../../Enums/Size.enum';
import CaseForwardConfirm from './CaseForwardConfirm';

interface Props {
	caseId: string;
	label: string;
	workplaceId?: string;
	workplaceMemberId?: string;
	onClose: () => void;
	onCaseForward: () => void;
	opened: boolean;
}

const CaseForwardConfirmModal: React.FC<Props> = props => {
	const { isCase } = useTreatmentContext();

	return (
		<Modal
			opened={props.opened}
			onClose={props.onClose}
			wrapChat={isCase}
			size={Size.MD}>
			<Modal.Header title={'base.shared.caseTransfer'} />
			<Modal.Content contentScroll>
				<CaseForwardConfirm {...props} />
			</Modal.Content>
		</Modal>
	);
};

export default CaseForwardConfirmModal;
